
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Check } from "lucide-react";
import { Link } from "react-router-dom";

const SimplifiedMembership = () => {
  const membershipFeatures = [
    "Monthly JUV Credits ($100 value)",
    "20-30% savings on all treatments", 
    "Priority booking and scheduling",
    "Exclusive member events and perks",
    "Birthday treatment discounts",
    "Free consultations included"
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-juv-soft-blush/30 to-white">
      <div className="container mx-auto px-6 max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-light text-juv-deep-chestnut mb-6">
            The JUV Membership
          </h2>
          <p className="text-lg md:text-xl text-juv-deep-chestnut/70 leading-relaxed max-w-3xl mx-auto mb-8">
            More than insurance. It's your beauty investment plan.
          </p>
          <div className="inline-block bg-white rounded-2xl p-6 shadow-luxury">
            <p className="text-2xl md:text-3xl font-bold text-juv-terracotta mb-2">
              Just $99/month
            </p>
            <p className="text-juv-deep-chestnut/70">
              For unlimited beauty possibilities
            </p>
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Features List */}
          <div>
            <Card className="shadow-luxury border-juv-rose-clay/20 bg-white/90 backdrop-blur-sm">
              <CardHeader>
                <CardTitle className="text-2xl font-serif text-juv-deep-chestnut mb-4">
                  What You Get Every Month
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  {membershipFeatures.map((feature, index) => (
                    <div key={index} className="flex items-center space-x-3">
                      <div className="w-6 h-6 bg-juv-terracotta rounded-full flex items-center justify-center flex-shrink-0">
                        <Check size={14} className="text-white" />
                      </div>
                      <span className="text-juv-deep-chestnut/80">{feature}</span>
                    </div>
                  ))}
                </div>
                
                <div className="mt-8 p-6 bg-juv-gradient-secondary rounded-xl border border-juv-rose-clay/20">
                  <p className="text-center text-juv-deep-chestnut font-semibold">
                    <span className="text-2xl font-bold">$3,000+ annual value</span>
                    <br />
                    <span className="text-lg">for just $1,188/year</span>
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Visual/Stats */}
          <div className="space-y-6">
            <Card className="bg-white/90 backdrop-blur-sm shadow-luxury border-juv-rose-clay/20 p-6 text-center">
              <div className="text-4xl font-bold text-juv-terracotta mb-2">2x</div>
              <p className="text-juv-deep-chestnut/70">More treatments per year vs traditional insurance</p>
            </Card>
            
            <Card className="bg-white/90 backdrop-blur-sm shadow-luxury border-juv-rose-clay/20 p-6 text-center">
              <div className="text-4xl font-bold text-juv-terracotta mb-2">0</div>
              <p className="text-juv-deep-chestnut/70">Waiting periods or claim denials</p>
            </Card>
            
            <Card className="bg-white/90 backdrop-blur-sm shadow-luxury border-juv-rose-clay/20 p-6 text-center">
              <div className="text-4xl font-bold text-juv-terracotta mb-2">30</div>
              <p className="text-juv-deep-chestnut/70">Day free trial to try risk-free</p>
            </Card>
          </div>
        </div>

        <div className="text-center mt-16">
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild size="lg" className="bg-juv-terracotta hover:bg-juv-deep-chestnut text-white px-8 py-4 rounded-full font-semibold">
              <Link to="/membership">Join the Membership</Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="border-juv-terracotta text-juv-terracotta hover:bg-juv-terracotta hover:text-white px-8 py-4 rounded-full font-semibold transition-all duration-300">
              <Link to="/membership-compare">Compare Plans</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SimplifiedMembership;
